import { useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TagList } from '@mews-commander/ui';
import { compactArray } from '@mews/fp';
import { Container } from '@optimus-web/core';
import { RoutingRuleListTableRowData } from '../types';

interface ConditionsCellProps {
    conditions: RoutingRuleListTableRowData['conditions'];
}

export const ConditionsCell: React.FC<ConditionsCellProps> = ({ conditions }) => {
    const lt = useLocalizeText();

    const { companies, travelAgencies, rates, prepayment } = conditions;

    const c = companies.length + travelAgencies.length;
    const r = rates.flatMap((rate) => rate.rates ?? []).length;

    const ratesWithServices = r
        ? rates.map((rate) => {
              const rateCount = rate.rates.length;
              return rateCount
                  ? `${rateCount} ${lt({
                        textKey: rateCount === 1 ? TextKey.Rate : TextKey.RatePlural,
                    }).toLowerCase()} - ${rate.serviceName}`
                  : null;
          })
        : [];

    return (
        <Container maxHeight="160px">
            <TagList
                vertical
                compact
                tagsVariant="basicSubtle"
                tags={compactArray([
                    prepayment ? lt({ textKey: TextKey.RoutingRulesTableReservationConditionsPrepaidInOTA }) : null,
                    c
                        ? `${c} ${lt({ textKey: c === 1 ? TextKey.Company : TextKey.CompanyPlural }).toLowerCase()}`
                        : null,
                    ...ratesWithServices,
                ])}
            />
        </Container>
    );
};
